import * as analytics from "./util/segment"

// This refreshes the potentially stale statically built href's for each
// packagebutton client-side.
export default class PackageButton {
    mount() {
        $(".package-button").each((i, el) => {
            const id = $(el).data("refresh");
            const { jsonUrl, target } = window.packageButtons[id];

            $.getJSON(jsonUrl).then(({ packages }) => {
                const href = `https://release.memsql.com/${
                    packages[target].Path
                }`;

                $(el).attr("href", href);

                $(el).click(() => {
                    analytics.track({
                        action: "package-button-clicked",
                        category: "guides",
                        label: `${target}-${href}`,
                    });
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/package-button.js